import http from '@/utils/http'

const phone = () => http()
  .post('/voip_credentials')

export default {
  phone
}



// WEBPACK FOOTER //
// ./src/api/credentials.js